import type { Board } from "@/model/board";
import type { BoardCard } from "@/model/card";
import type { DependencyTeamFilter } from "@/model/search";

export function fadeOutCard(card: BoardCard, fadeOut: boolean) {
  card.meta.mark = fadeOut ? "fade-out" : "normal";
}

function linkFadeOutCard(card: BoardCard) {
  card.meta.mark = "fade-out";
  card.meta.isHighlighted = false;
  card.meta.isRelatedToHighlighted = false;
}

export function linkHighlightCard(card: BoardCard, near: boolean) {
  card.meta.mark = near ? "normal" : "semi-fade-out";
  card.meta.isRelatedToHighlighted = true;
}

export function highlightCard(card: BoardCard) {
  card.meta.mark = "normal";
  card.meta.isHighlighted = true;
}

export function hideCard(card: BoardCard) {
  card.meta.mark = "hidden";
}

export function setSearchCardMark(
  card: BoardCard,
  match: boolean,
  hide: boolean,
  dependencyTeamFilter: DependencyTeamFilter | null,
) {
  card.meta.mark = match ? "normal" : hide ? "filter-out" : "fade-out";
  card.meta.dependencyTeamFilter = dependencyTeamFilter;
}

export function resetCardMark(card?: BoardCard) {
  const meta = card?.meta;
  if (meta) {
    meta.mark = "normal";
    meta.isHighlighted = false;
    meta.isRelatedToHighlighted = false;
    meta.dependencyTeamFilter = null;
  }
}

export function fadeOutAllCardMarks(board: Board) {
  Object.values(board.cards).forEach((card) => fadeOutCard(card, true));
}

export function resetAllCardMarks(board: Board) {
  Object.values(board.cards).forEach(resetCardMark);
}

export function markLinkedCard(card: BoardCard, distance?: number): boolean {
  if (distance === undefined || distance > 2) {
    linkFadeOutCard(card);
    return false;
  }
  if (distance > 0) {
    linkHighlightCard(card, distance === 1);
  } else {
    highlightCard(card);
  }
  return true;
}
